import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const StatisticsRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: ${theme.spacing.sm};
  gap: ${theme.spacing.sm};
`
export const StatisticContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacing.md} ${theme.spacing.sm};
  justify-content: space-between;
  background: ${theme.colors.neutral.white};
  border-radius: ${theme.shapes.borderRadius.md};
  padding: ${theme.spacing.sm} ${theme.spacing.xm};
  box-shadow: 0px 0px 6px rgba(92, 92, 92, 0.102);
  flex-grow: 1;
`

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${theme.spacing.xl};
  gap: ${theme.spacing.sm};
`

export const IconContainer = styled.div`
  height: 45px;
  width: 45px;
  background-color: ${theme.colors.neutral.wrapicon};
  border-radius: ${theme.shapes.borderRadius.sm};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TitleCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;

  span {
    font-weight: ${theme.typography.weight.md};
    font-size: ${theme.typography.sizes['2xs']};
    color: ${theme.colors.neutral.medium};
  }

  h5 {
    margin: 0;
    line-height: ${theme.typography.lineHeight.sm};
    font-family: ${theme.typography.family.bold};
    font-weight: ${theme.typography.weight.lg};
    font-size: ${theme.typography.sizes['2md']};
    color: ${theme.colors.neutral.black};
  }
`
type DetailsColProps = {
  childrenOrientation: 'row' | 'column'
}

export const DetailsCol = styled.div<DetailsColProps>`
  display: flex;
  flex-direction: ${({ childrenOrientation }) => childrenOrientation};
  justify-content: center;
  gap: ${theme.spacing.xs};
  flex: 1;
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
`
